const staticText = {
  title: 'Subscribe to webhook',
  subscribeVehicles: count => `Choose a webhook to subscribe your (${count}) selected vehicles to:`,
  subscribeVehicleByName: name => `Choose a webhook to subscribe the |*|bold@@${name}|*| to:`,
  cancel: 'Cancel',
  subscribe: 'Subscribe',
  cannotManageVehicles: 'It looks like you don\'t have permission to subscribe vehicles for this application. Please contact a team owner or admin.',
  emptyState: {
    noWebhooks: 'No webhooks found',
    addWebhook: 'Add webhook',
  },
  featureGated: {
    upgradeCta: 'Upgrade to add webhooks',
    contactOwnersToUpgrade: 'Contact a team owner to upgrade to add webhooks & subscribe vehicles',
  },
  legacyWebhooks: 'To subscribe vehicles to any legacy webhooks, please refer to our |+|documentation@@https://smartcar.com/docs/api-reference/webhooks/subscribe-webhook|+|.',
};

export default staticText;
